import classNames from 'classnames'

import { useThemeMode } from '../../../hooks'
import {
  linkifyHtml,
  newLineToBrInHtml,
  openHtmlLinksInNewTab,
} from '../../../utils/html'
import { getThemeContentHtml } from '../../../utils/themeContent'
import {
  getChatroomMessageEditedAt,
  isChatroomMessageEdited,
} from '../Chatroom.utils'
import { ChatroomMessageEditedMarker } from '../ChatroomMessageEditedMarker'
import { ChatroomMessageFiles } from '../ChatroomMessageFiles'
import { ChatroomMessageFooter } from '../ChatroomMessageFooter'
import { ChatroomMessageLinkedRequests } from '../ChatroomMessageLinkedRequests'

import * as styles from './ChatroomMessageBody.module.css'

function ChatroomMessageBody({
  filePreviewProps,
  files,
  isLiked,
  isOwnMessage,
  isPrivate,
  likeCount,
  message,
  outboundUuid,
  timeLabel,
  onEditMessage,
  onLike,
  onRefetchVisibleMessages,
  onUpdateMessage,
}) {
  const { theme } = useThemeMode()

  const isEdited = isChatroomMessageEdited(message)

  const bodyClassName = classNames(styles.chatroomMessageBody, {
    [styles.chatroomMessageBodyOwn]: isOwnMessage,
    [styles.chatroomMessageBodyPrivate]: isPrivate && !isOwnMessage,
  })

  const textClassName = classNames(styles.text, {
    [styles.textEdited]: isEdited,
  })

  return (
    <div className={bodyClassName}>
      <div className={styles.textWrap}>
        <div
          className={textClassName}
          dangerouslySetInnerHTML={{
            __html: getThemeContentHtml(
              openHtmlLinksInNewTab(
                linkifyHtml(newLineToBrInHtml(message.text))
              ),
              theme
            ),
          }}
        />
        {isEdited ? (
          <ChatroomMessageEditedMarker
            editedAt={getChatroomMessageEditedAt(message)}
          />
        ) : null}
      </div>
      <ChatroomMessageLinkedRequests linkedRequests={message.linked_requests} />
      {files.length > 0 ? (
        <ChatroomMessageFiles
          filePreviewProps={filePreviewProps}
          files={files}
          message={message}
        />
      ) : null}
      <ChatroomMessageFooter
        isLiked={isLiked}
        likeCount={likeCount}
        message={message}
        outboundUuid={outboundUuid}
        timeLabel={timeLabel}
        onEditMessage={onEditMessage}
        onLike={onLike}
        onRefetchVisibleMessages={onRefetchVisibleMessages}
        onUpdateMessage={onUpdateMessage}
      />
    </div>
  )
}

export default ChatroomMessageBody
